<template>
<div>
  <h1>Login</h1>
  <form action="javascript:void(0);">
    <label>Email Address:</label>
    <input v-model="formEmail" type='text'>
    <label>Password:</label>
    <input v-model="formPassword" type='password'>
    <button class="btn-secondary" @click="login()">Log In</button>
    <span v-show='loginSuccess===false'>Double check your email/password</span>
  </form>
</div>
</template>

<script>
export default {
  data() {
    return {
      formEmail: "",
      formPassword: "",
      loginSuccess: null
    };
  },
  computed: {},
  methods: {
    login: function() {
      this.$store.dispatch("users/login", {
          email: this.formEmail,
          password: this.formPassword
        })
        .then(r => {
          this.loginSuccess = r.success;
        })
        .catch(r => {
          this.loginSuccess = false;
        });
    }
  },
  components: {},
  mounted: function() {}
};
</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/login.vue